var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":"transparent"}},[_c('div',[_c('apexChart',{attrs:{"width":"100%","height":"100px","type":"area","options":_vm.options,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }